// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* === Ticket Details Modal === */

.TicketDetailsModal_overlay__bVFUn {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  z-index: 1000;
  padding: 24px 16px;
  overflow-y: auto;
}

.TicketDetailsModal_modal__zslwS {
  background-color: #181a1b;
  color: #ffffff;
  border-radius: 10px;
  width: 100%;
  max-width: 680px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.75);
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 48px);
  margin: auto;
}

.TicketDetailsModal_header__B8tLc {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #2c2f31;
  flex-shrink: 0;
}

.TicketDetailsModal_headerTitle__AzUrX {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}

.TicketDetailsModal_iconButton__0Jcnu {
  background: none;
  border: none;
  color: #999999;
  cursor: pointer;
  font-size: 20px;
  padding: 4px 8px;
  border-radius: 6px;
  line-height: 1;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.TicketDetailsModal_iconButton__0Jcnu:hover {
  background-color: #2a2d31;
  color: #ffffff;
}

.TicketDetailsModal_body__kka6z {
  padding: 18px 20px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.25) transparent;
}

.TicketDetailsModal_body__kka6z::-webkit-scrollbar { width: 8px; }
.TicketDetailsModal_body__kka6z::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
}

.TicketDetailsModal_section__KQkfT {
  margin-bottom: 22px;
}

.TicketDetailsModal_section__KQkfT:last-child {
  margin-bottom: 0;
}

.TicketDetailsModal_sectionTitle__AFLcK {
  margin: 0 0 10px 0;
  font-size: 13px;
  font-weight: 600;
  color: #999999;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.TicketDetailsModal_sectionBadge__iVaJX {
  background-color: #2a2d31;
  color: #cccccc;
  font-size: 11px;
  padding: 1px 7px;
  border-radius: 10px;
  font-weight: 500;
  letter-spacing: 0;
  text-transform: none;
}

/* === Info grid === */

.TicketDetailsModal_infoGrid__8Uc1E {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 4px 14px;
  font-size: 14px;
}

.TicketDetailsModal_infoLabel__YgFpM {
  color: #777777;
  font-weight: 500;
}

.TicketDetailsModal_infoValue__4wi4U {
  color: #e8e8e8;
  word-break: break-word;
  white-space: pre-wrap;
}

.TicketDetailsModal_zohoBox__jgD8N {
  margin-top: 12px;
  padding: 10px 12px;
  background-color: rgba(155, 89, 182, 0.12);
  border-radius: 6px;
  border-left: 3px solid #9b59b6;
}

.TicketDetailsModal_zohoTitle__Cpx0O {
  margin: 0 0 6px 0;
  font-weight: 600;
  color: #9b59b6;
  font-size: 12px;
}

.TicketDetailsModal_zohoLine__oGYw5 {
  margin: 0 0 3px 0;
  font-size: 12px;
  color: #cccccc;
}

.TicketDetailsModal_zohoLink__bOlGg {
  color: #9b59b6;
  text-decoration: none;
  font-size: 12px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-top: 4px;
}

.TicketDetailsModal_zohoLink__bOlGg:hover {
  text-decoration: underline;
}

/* === Time tracking === */

.TicketDetailsModal_timeTotal__qIWWU {
  background-color: rgba(0, 123, 255, 0.1);
  padding: 10px 12px;
  border-radius: 6px;
  margin-bottom: 10px;
}

.TicketDetailsModal_timeTotalValue__X6syZ {
  margin: 0;
  color: #4a9eff;
  font-weight: 600;
  font-size: 14px;
}

.TicketDetailsModal_timeEntries__fIMfs {
  max-height: 200px;
  overflow-y: auto;
  background-color: rgba(255, 255, 255, 0.04);
  border-radius: 6px;
  padding: 10px;
  scrollbar-width: thin;
}

.TicketDetailsModal_timeEntry__3h9vr {
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  padding-bottom: 8px;
  margin-bottom: 8px;
}

.TicketDetailsModal_timeEntry__3h9vr:last-child {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

.TicketDetailsModal_timeEntryRow__FBF48 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

.TicketDetailsModal_timeEntryTime__fX94D {
  font-size: 12px;
  color: #bbbbbb;
}

.TicketDetailsModal_timeEntryDuration__vJocY {
  font-weight: 600;
  color: #28a745;
  font-size: 13px;
}

.TicketDetailsModal_timeEntryStep__SfXMt {
  font-size: 11px;
  color: #ffc107;
  font-style: italic;
  margin-top: 3px;
}

.TicketDetailsModal_timeEntryDesc__e3x1d {
  font-size: 11px;
  color: #bbbbbb;
  font-style: italic;
  margin-top: 2px;
}

.TicketDetailsModal_timeMore__mQbo0 {
  text-align: center;
  color: #888888;
  font-size: 12px;
  margin-top: 6px;
}

.TicketDetailsModal_loadingText__bJ6oP {
  color: #bbbbbb;
  font-size: 13px;
}

/* === List items (todos + steps) === */

.TicketDetailsModal_list__ie5qI {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.TicketDetailsModal_item__pzi5y {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 9px 11px;
  background-color: rgba(255, 255, 255, 0.04);
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  transition: background-color 0.15s ease, border-color 0.15s ease;
}

.TicketDetailsModal_item__pzi5y:hover {
  background-color: rgba(255, 255, 255, 0.07);
  border-color: rgba(255, 255, 255, 0.16);
}

.TicketDetailsModal_itemMain__Eaxh4 {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.TicketDetailsModal_itemText__Qweb9 {
  color: #e8e8e8;
  font-size: 14px;
  line-height: 1.4;
  word-break: break-word;
  white-space: pre-wrap;
}

.TicketDetailsModal_itemDate__\\+ejRv {
  font-size: 11px;
  color: #777777;
  font-style: italic;
}

.TicketDetailsModal_itemActions__Pj9Ym {
  display: flex;
  align-items: center;
  gap: 2px;
  flex-shrink: 0;
}

.TicketDetailsModal_actionBtn__NyfvC {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px 6px;
  border-radius: 4px;
  font-size: 13px;
  line-height: 1;
  color: #888888;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.TicketDetailsModal_actionBtn__NyfvC:hover {
  background-color: rgba(255, 255, 255, 0.1);
  color: #ffffff;
}

.TicketDetailsModal_actionBtnDanger__ERMun {
  color: #888888;
}

.TicketDetailsModal_actionBtnDanger__ERMun:hover {
  color: #dc3545;
}

.TicketDetailsModal_actionBtnSuccess__A44Cc {
  color: #888888;
}

.TicketDetailsModal_actionBtnSuccess__A44Cc:hover {
  color: #28a745;
}

.TicketDetailsModal_actionBtnDone__xXESL {
  color: #28a745;
  font-weight: 600;
  white-space: nowrap;
}

.TicketDetailsModal_actionBtnDone__xXESL:hover {
  background-color: rgba(40, 167, 69, 0.15);
  color: #1e7e34;
}

.TicketDetailsModal_actionBtnRestore__Bt\\+ac {
  color: #17a2b8;
  font-weight: 600;
  white-space: nowrap;
}

.TicketDetailsModal_actionBtnRestore__Bt\\+ac:hover {
  background-color: rgba(23, 162, 184, 0.15);
  color: #117a8b;
}

.TicketDetailsModal_actionBtnDelete__5M6dd {
  color: #dc3545;
  font-weight: 600;
  white-space: nowrap;
}

.TicketDetailsModal_actionBtnDelete__5M6dd:hover {
  background-color: rgba(220, 53, 69, 0.15);
  color: #a71d2a;
}

.TicketDetailsModal_todoCheck__0C5Py {
  width: 18px;
  height: 18px;
  border-radius: 4px;
  border: 1.5px solid #555555;
  background-color: transparent;
  cursor: pointer;
  flex-shrink: 0;
  margin-top: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: transparent;
  font-size: 11px;
  transition: border-color 0.15s ease, background-color 0.15s ease, color 0.15s ease;
}

.TicketDetailsModal_todoCheck__0C5Py:hover {
  border-color: #28a745;
  color: #28a745;
}

.TicketDetailsModal_editInput__cBcNg {
  flex: 1 1;
  background-color: #23272a;
  border: 1px solid #4a9eff;
  border-radius: 4px;
  color: #ffffff;
  padding: 5px 8px;
  font-size: 14px;
  font-family: inherit;
  outline: none;
  min-width: 0;
}

.TicketDetailsModal_datePicker__nxWFT {
  background-color: #23272a;
  border: 1px solid #444444;
  border-radius: 4px;
  color: #ffffff;
  padding: 3px 6px;
  font-size: 12px;
}

.TicketDetailsModal_emptyState__7g6ks {
  color: #777777;
  font-size: 13px;
  font-style: italic;
  padding: 4px 0;
}

/* === Add row === */

.TicketDetailsModal_addRow__OPurL {
  display: flex;
  gap: 8px;
  margin-top: 8px;
}

.TicketDetailsModal_addInput__LyKyA {
  flex: 1 1;
  background-color: #23272a;
  border: 1px solid #444444;
  border-radius: 6px;
  color: #ffffff;
  padding: 8px 12px;
  font-size: 14px;
  font-family: inherit;
  outline: none;
  min-width: 0;
  transition: border-color 0.15s ease;
}

.TicketDetailsModal_addInput__LyKyA:focus {
  border-color: #4a9eff;
}

.TicketDetailsModal_addBtn__dhVT0 {
  padding: 8px 16px;
  background-color: #4a9eff;
  color: #ffffff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.15s ease;
  flex-shrink: 0;
}

.TicketDetailsModal_addBtn__dhVT0:hover {
  background-color: #3a8aff;
}

.TicketDetailsModal_addBtn__dhVT0:disabled {
  background-color: #3a3d42;
  cursor: not-allowed;
}

/* === Footer === */

.TicketDetailsModal_footer__2DO\\+j {
  padding: 14px 20px;
  border-top: 1px solid #2c2f31;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  flex-shrink: 0;
}

.TicketDetailsModal_closeBtn__lKQFu {
  padding: 8px 18px;
  background-color: #2a2d31;
  color: #ffffff;
  border: 1px solid #444444;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.15s ease;
}

.TicketDetailsModal_closeBtn__lKQFu:hover {
  background-color: #3a3d42;
}

@media (max-width: 520px) {
  .TicketDetailsModal_overlay__bVFUn {
    padding: 0;
  }
  .TicketDetailsModal_modal__zslwS {
    max-width: 100%;
    max-height: 100vh;
    border-radius: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/TicketDetailsModal.module.css"],"names":[],"mappings":"AAAA,iCAAiC;;AAEjC;EACE,eAAe;EACf,QAAQ;EACR,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,yDAAyD;AAC3D;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,sDAAsD;AACxD;;AAEA,qDAA2B,UAAU,EAAE;AACvC;EACE,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,sBAAsB;;AAEtB;EACE,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;EAC1C,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,0BAA0B;;AAE1B;EACE,wCAAwC;EACxC,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,kDAAkD;EAClD,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,uCAAuC;;AAEvC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,2CAA2C;EAC3C,kBAAkB;EAClB,2CAA2C;EAC3C,gEAAgE;AAClE;;AAEA;EACE,2CAA2C;EAC3C,uCAAuC;AACzC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,cAAc;EACd,yDAAyD;AAC3D;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,6BAA6B;EAC7B,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,kFAAkF;AACpF;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA,oBAAoB;;AAEpB;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,mBAAmB;;AAEnB;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;AACF","sourcesContent":["/* === Ticket Details Modal === */\n\n.overlay {\n  position: fixed;\n  inset: 0;\n  background-color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  z-index: 1000;\n  padding: 24px 16px;\n  overflow-y: auto;\n}\n\n.modal {\n  background-color: #181a1b;\n  color: #ffffff;\n  border-radius: 10px;\n  width: 100%;\n  max-width: 680px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.75);\n  display: flex;\n  flex-direction: column;\n  max-height: calc(100vh - 48px);\n  margin: auto;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  border-bottom: 1px solid #2c2f31;\n  flex-shrink: 0;\n}\n\n.headerTitle {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.iconButton {\n  background: none;\n  border: none;\n  color: #999999;\n  cursor: pointer;\n  font-size: 20px;\n  padding: 4px 8px;\n  border-radius: 6px;\n  line-height: 1;\n  transition: background-color 0.15s ease, color 0.15s ease;\n}\n\n.iconButton:hover {\n  background-color: #2a2d31;\n  color: #ffffff;\n}\n\n.body {\n  padding: 18px 20px;\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.25) transparent;\n}\n\n.body::-webkit-scrollbar { width: 8px; }\n.body::-webkit-scrollbar-thumb {\n  background-color: rgba(255, 255, 255, 0.2);\n  border-radius: 4px;\n}\n\n.section {\n  margin-bottom: 22px;\n}\n\n.section:last-child {\n  margin-bottom: 0;\n}\n\n.sectionTitle {\n  margin: 0 0 10px 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: #999999;\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.sectionBadge {\n  background-color: #2a2d31;\n  color: #cccccc;\n  font-size: 11px;\n  padding: 1px 7px;\n  border-radius: 10px;\n  font-weight: 500;\n  letter-spacing: 0;\n  text-transform: none;\n}\n\n/* === Info grid === */\n\n.infoGrid {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  gap: 4px 14px;\n  font-size: 14px;\n}\n\n.infoLabel {\n  color: #777777;\n  font-weight: 500;\n}\n\n.infoValue {\n  color: #e8e8e8;\n  word-break: break-word;\n  white-space: pre-wrap;\n}\n\n.zohoBox {\n  margin-top: 12px;\n  padding: 10px 12px;\n  background-color: rgba(155, 89, 182, 0.12);\n  border-radius: 6px;\n  border-left: 3px solid #9b59b6;\n}\n\n.zohoTitle {\n  margin: 0 0 6px 0;\n  font-weight: 600;\n  color: #9b59b6;\n  font-size: 12px;\n}\n\n.zohoLine {\n  margin: 0 0 3px 0;\n  font-size: 12px;\n  color: #cccccc;\n}\n\n.zohoLink {\n  color: #9b59b6;\n  text-decoration: none;\n  font-size: 12px;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  margin-top: 4px;\n}\n\n.zohoLink:hover {\n  text-decoration: underline;\n}\n\n/* === Time tracking === */\n\n.timeTotal {\n  background-color: rgba(0, 123, 255, 0.1);\n  padding: 10px 12px;\n  border-radius: 6px;\n  margin-bottom: 10px;\n}\n\n.timeTotalValue {\n  margin: 0;\n  color: #4a9eff;\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.timeEntries {\n  max-height: 200px;\n  overflow-y: auto;\n  background-color: rgba(255, 255, 255, 0.04);\n  border-radius: 6px;\n  padding: 10px;\n  scrollbar-width: thin;\n}\n\n.timeEntry {\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  padding-bottom: 8px;\n  margin-bottom: 8px;\n}\n\n.timeEntry:last-child {\n  border-bottom: none;\n  margin-bottom: 0;\n  padding-bottom: 0;\n}\n\n.timeEntryRow {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n}\n\n.timeEntryTime {\n  font-size: 12px;\n  color: #bbbbbb;\n}\n\n.timeEntryDuration {\n  font-weight: 600;\n  color: #28a745;\n  font-size: 13px;\n}\n\n.timeEntryStep {\n  font-size: 11px;\n  color: #ffc107;\n  font-style: italic;\n  margin-top: 3px;\n}\n\n.timeEntryDesc {\n  font-size: 11px;\n  color: #bbbbbb;\n  font-style: italic;\n  margin-top: 2px;\n}\n\n.timeMore {\n  text-align: center;\n  color: #888888;\n  font-size: 12px;\n  margin-top: 6px;\n}\n\n.loadingText {\n  color: #bbbbbb;\n  font-size: 13px;\n}\n\n/* === List items (todos + steps) === */\n\n.list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.item {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 9px 11px;\n  background-color: rgba(255, 255, 255, 0.04);\n  border-radius: 6px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  transition: background-color 0.15s ease, border-color 0.15s ease;\n}\n\n.item:hover {\n  background-color: rgba(255, 255, 255, 0.07);\n  border-color: rgba(255, 255, 255, 0.16);\n}\n\n.itemMain {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.itemText {\n  color: #e8e8e8;\n  font-size: 14px;\n  line-height: 1.4;\n  word-break: break-word;\n  white-space: pre-wrap;\n}\n\n.itemDate {\n  font-size: 11px;\n  color: #777777;\n  font-style: italic;\n}\n\n.itemActions {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  flex-shrink: 0;\n}\n\n.actionBtn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 4px 6px;\n  border-radius: 4px;\n  font-size: 13px;\n  line-height: 1;\n  color: #888888;\n  transition: background-color 0.15s ease, color 0.15s ease;\n}\n\n.actionBtn:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n  color: #ffffff;\n}\n\n.actionBtnDanger {\n  color: #888888;\n}\n\n.actionBtnDanger:hover {\n  color: #dc3545;\n}\n\n.actionBtnSuccess {\n  color: #888888;\n}\n\n.actionBtnSuccess:hover {\n  color: #28a745;\n}\n\n.actionBtnDone {\n  color: #28a745;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.actionBtnDone:hover {\n  background-color: rgba(40, 167, 69, 0.15);\n  color: #1e7e34;\n}\n\n.actionBtnRestore {\n  color: #17a2b8;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.actionBtnRestore:hover {\n  background-color: rgba(23, 162, 184, 0.15);\n  color: #117a8b;\n}\n\n.actionBtnDelete {\n  color: #dc3545;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.actionBtnDelete:hover {\n  background-color: rgba(220, 53, 69, 0.15);\n  color: #a71d2a;\n}\n\n.todoCheck {\n  width: 18px;\n  height: 18px;\n  border-radius: 4px;\n  border: 1.5px solid #555555;\n  background-color: transparent;\n  cursor: pointer;\n  flex-shrink: 0;\n  margin-top: 1px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: transparent;\n  font-size: 11px;\n  transition: border-color 0.15s ease, background-color 0.15s ease, color 0.15s ease;\n}\n\n.todoCheck:hover {\n  border-color: #28a745;\n  color: #28a745;\n}\n\n.editInput {\n  flex: 1;\n  background-color: #23272a;\n  border: 1px solid #4a9eff;\n  border-radius: 4px;\n  color: #ffffff;\n  padding: 5px 8px;\n  font-size: 14px;\n  font-family: inherit;\n  outline: none;\n  min-width: 0;\n}\n\n.datePicker {\n  background-color: #23272a;\n  border: 1px solid #444444;\n  border-radius: 4px;\n  color: #ffffff;\n  padding: 3px 6px;\n  font-size: 12px;\n}\n\n.emptyState {\n  color: #777777;\n  font-size: 13px;\n  font-style: italic;\n  padding: 4px 0;\n}\n\n/* === Add row === */\n\n.addRow {\n  display: flex;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.addInput {\n  flex: 1;\n  background-color: #23272a;\n  border: 1px solid #444444;\n  border-radius: 6px;\n  color: #ffffff;\n  padding: 8px 12px;\n  font-size: 14px;\n  font-family: inherit;\n  outline: none;\n  min-width: 0;\n  transition: border-color 0.15s ease;\n}\n\n.addInput:focus {\n  border-color: #4a9eff;\n}\n\n.addBtn {\n  padding: 8px 16px;\n  background-color: #4a9eff;\n  color: #ffffff;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: background-color 0.15s ease;\n  flex-shrink: 0;\n}\n\n.addBtn:hover {\n  background-color: #3a8aff;\n}\n\n.addBtn:disabled {\n  background-color: #3a3d42;\n  cursor: not-allowed;\n}\n\n/* === Footer === */\n\n.footer {\n  padding: 14px 20px;\n  border-top: 1px solid #2c2f31;\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.closeBtn {\n  padding: 8px 18px;\n  background-color: #2a2d31;\n  color: #ffffff;\n  border: 1px solid #444444;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background-color 0.15s ease;\n}\n\n.closeBtn:hover {\n  background-color: #3a3d42;\n}\n\n@media (max-width: 520px) {\n  .overlay {\n    padding: 0;\n  }\n  .modal {\n    max-width: 100%;\n    max-height: 100vh;\n    border-radius: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `TicketDetailsModal_overlay__bVFUn`,
	"modal": `TicketDetailsModal_modal__zslwS`,
	"header": `TicketDetailsModal_header__B8tLc`,
	"headerTitle": `TicketDetailsModal_headerTitle__AzUrX`,
	"iconButton": `TicketDetailsModal_iconButton__0Jcnu`,
	"body": `TicketDetailsModal_body__kka6z`,
	"section": `TicketDetailsModal_section__KQkfT`,
	"sectionTitle": `TicketDetailsModal_sectionTitle__AFLcK`,
	"sectionBadge": `TicketDetailsModal_sectionBadge__iVaJX`,
	"infoGrid": `TicketDetailsModal_infoGrid__8Uc1E`,
	"infoLabel": `TicketDetailsModal_infoLabel__YgFpM`,
	"infoValue": `TicketDetailsModal_infoValue__4wi4U`,
	"zohoBox": `TicketDetailsModal_zohoBox__jgD8N`,
	"zohoTitle": `TicketDetailsModal_zohoTitle__Cpx0O`,
	"zohoLine": `TicketDetailsModal_zohoLine__oGYw5`,
	"zohoLink": `TicketDetailsModal_zohoLink__bOlGg`,
	"timeTotal": `TicketDetailsModal_timeTotal__qIWWU`,
	"timeTotalValue": `TicketDetailsModal_timeTotalValue__X6syZ`,
	"timeEntries": `TicketDetailsModal_timeEntries__fIMfs`,
	"timeEntry": `TicketDetailsModal_timeEntry__3h9vr`,
	"timeEntryRow": `TicketDetailsModal_timeEntryRow__FBF48`,
	"timeEntryTime": `TicketDetailsModal_timeEntryTime__fX94D`,
	"timeEntryDuration": `TicketDetailsModal_timeEntryDuration__vJocY`,
	"timeEntryStep": `TicketDetailsModal_timeEntryStep__SfXMt`,
	"timeEntryDesc": `TicketDetailsModal_timeEntryDesc__e3x1d`,
	"timeMore": `TicketDetailsModal_timeMore__mQbo0`,
	"loadingText": `TicketDetailsModal_loadingText__bJ6oP`,
	"list": `TicketDetailsModal_list__ie5qI`,
	"item": `TicketDetailsModal_item__pzi5y`,
	"itemMain": `TicketDetailsModal_itemMain__Eaxh4`,
	"itemText": `TicketDetailsModal_itemText__Qweb9`,
	"itemDate": `TicketDetailsModal_itemDate__+ejRv`,
	"itemActions": `TicketDetailsModal_itemActions__Pj9Ym`,
	"actionBtn": `TicketDetailsModal_actionBtn__NyfvC`,
	"actionBtnDanger": `TicketDetailsModal_actionBtnDanger__ERMun`,
	"actionBtnSuccess": `TicketDetailsModal_actionBtnSuccess__A44Cc`,
	"actionBtnDone": `TicketDetailsModal_actionBtnDone__xXESL`,
	"actionBtnRestore": `TicketDetailsModal_actionBtnRestore__Bt+ac`,
	"actionBtnDelete": `TicketDetailsModal_actionBtnDelete__5M6dd`,
	"todoCheck": `TicketDetailsModal_todoCheck__0C5Py`,
	"editInput": `TicketDetailsModal_editInput__cBcNg`,
	"datePicker": `TicketDetailsModal_datePicker__nxWFT`,
	"emptyState": `TicketDetailsModal_emptyState__7g6ks`,
	"addRow": `TicketDetailsModal_addRow__OPurL`,
	"addInput": `TicketDetailsModal_addInput__LyKyA`,
	"addBtn": `TicketDetailsModal_addBtn__dhVT0`,
	"footer": `TicketDetailsModal_footer__2DO+j`,
	"closeBtn": `TicketDetailsModal_closeBtn__lKQFu`
};
export default ___CSS_LOADER_EXPORT___;
